import dynamic from 'next/dynamic';
import { forwardRef } from 'react';

import LazyHydratedGooglePublisherTagLandscapeAdSlot from 'components/AdSlots/GooglePublisherTagLandscapeAdSlot/LazyHydratedGooglePublisherTagLandscapeAdSlot';
import ErrorBoundary from 'components/ErrorBoundary';
import LazyHydration from 'components/LazyHydration';

import useCommentIdFromRouterHash from 'hooks/useCommentIdFromRouterHash';

const CommentsList = dynamic(() => import('.'), {
  ssr: false,
});

const ErrorBoundaryFallback = dynamic(() => import('./ErrorBoundaryFallback'), {
  ssr: false,
});

const DynamicallyLoadedCommentsList = forwardRef(
  ({ articleCommentsCount, articleId, isCommentsAllowed }, ref) => {
    const { isValidCommentIdHashAvailable } = useCommentIdFromRouterHash();

    return (
      <>
        {/* Placeholder div to use its ref instead of
          `OfferComments` components if it is not loaded yet */}
        <div ref={ref} />
        <LazyHydration
          force={isValidCommentIdHashAvailable}
          placeholderSize={{ height: 316, width: 330 }}
        >
          <ErrorBoundary fallback={ErrorBoundaryFallback}>
            <CommentsList
              articleCommentsCount={articleCommentsCount}
              articleId={articleId}
              isCommentsAllowed={isCommentsAllowed}
            />
            <LazyHydratedGooglePublisherTagLandscapeAdSlot
              adId="blog_article_page_main_content_2_320x50_468x60_728x90"
              adPath="/promobit.com.br_blog_article_page/main_content_2_320x50_468x60_728x90"
              className="mt-4"
            />
          </ErrorBoundary>
        </LazyHydration>
      </>
    );
  }
);

DynamicallyLoadedCommentsList.displayName =
  'DynamicallyLoadedArticleCommentsWithRef';

export default DynamicallyLoadedCommentsList;
